// extracted by mini-css-extract-plugin
export var cartContainer = "_ms-4";
export var gray = "_ms-1";
export var itemContainer = "_ms-2";
export var itemDetails = "_ms-3";
export var strong = "_ms-0";